import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, BookOpenCheck, ChevronDown, GraduationCap, HeartPulse, Microscope, Stethoscope, Users2 } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { Item, Reveal, Stagger } from "../Reveal";
import { SectionHead } from "./Sections";

const AUDIENCE_ICONS = [Stethoscope, GraduationCap, HeartPulse, Microscope, Users2, BookOpenCheck];

export const About = () => {
  const { t, rtl } = useLang();
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  return (
    <section className="section" id="about" data-testid="about-section">
      <div className="container about">
        <Reveal>
          <span className="kicker">{t.about.kicker}</span>
          <h2 className="about-title">{t.about.title}</h2>
          {t.about.paragraphs.map((p) => <p key={p} className="about-p">{p}</p>)}
          <Link to="/opportunities" className="btn btn-primary" style={{ marginTop: 22 }} data-testid="about-browse-button">{t.hero.cta}<Arrow size={17} /></Link>
        </Reveal>
        <Stagger className="about-cards" stagger={0.08}>
          {t.about.cards.map(([title, text], i) => <Item className="about-card" key={title}><span className="num">0{i + 1}</span><b>{title}</b><p>{text}</p></Item>)}
        </Stagger>
      </div>
    </section>
  );
};

export const Audience = () => {
  const { t } = useLang();
  return (
    <section className="section" style={{ background: "var(--surface)", borderBlock: "1px solid var(--line)" }} data-testid="audience-section">
      <div className="container">
        <SectionHead kicker={t.audience.kicker} title={t.audience.title} sub={t.audience.sub} />
        <Stagger className="aud-grid" stagger={0.06}>
          {t.audience.items.map(([title, text], i) => { const I = AUDIENCE_ICONS[i]; return <Item className="aud-item" key={title}><span className="wi"><I size={20} /></span><b>{title}</b><p>{text}</p></Item>; })}
        </Stagger>
      </div>
    </section>
  );
};

export const FAQ = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);
  return (
    <section className="section" id="faq" data-testid="faq-section">
      <div className="container faq">
        <Reveal><span className="kicker">{t.faq.kicker}</span><h2 className="about-title">{t.faq.title}</h2><p className="about-p">{t.faq.sub}</p></Reveal>
        <div className="faq-list">
          {t.faq.items.map(([q, a], i) => (
            <Reveal key={q} delay={i * 0.04}>
              <div className={`faq-item ${open === i ? "open" : ""}`}>
                <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-${i}`}>{q}<ChevronDown size={18} /></button>
                {open === i && <p className="faq-a">{a}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
